import { render, staticRenderFns } from "./SponsorePayments.vue?vue&type=template&id=16a2df50"
import script from "./SponsorePayments.vue?vue&type=script&lang=js"
export * from "./SponsorePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports